import {
  type ISkeletonRectangleProps,
  SkeletonEllipse,
  SkeletonRectangle,
} from 'shared/ui/Skeleton'
import styles from './styles.module.scss'

type ISkeletonMenuCardProps = {
  skeletonRectangleProps?: ISkeletonRectangleProps
}

export const SkeletonMenuCard = ({ skeletonRectangleProps }: ISkeletonMenuCardProps) => {
  return (
    <div className={styles.wrap}>
      <div className={styles.ellipse}>
        <SkeletonEllipse animated />
      </div>
      <SkeletonRectangle animated {...skeletonRectangleProps} />
    </div>
  )
}
